import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const NewIndex = lazy(() => import('./new/Index'))

export const MissionRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--mission']}>
    <Route path='new' element={<NewIndex />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
